interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Usdt = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="100"
      height="100"
      rx="50"
      fill="#50AF95"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6971 51.9527C55.3789 51.9768 53.7348 52.0757 50.0676 52.0757C47.1508 52.0757 45.0799 51.9875 44.3533 51.9527C33.0812 51.4528 24.6676 49.4747 24.6676 47.1064C24.6676 44.738 33.0812 42.7626 44.3533 42.2547V49.9826C45.0905 50.0361 47.2012 50.1617 50.118 50.1617C53.6182 50.1617 55.3709 50.0147 55.6864 49.9853V42.26C66.9347 42.7652 75.3298 44.7433 75.3298 47.1064C75.3298 49.4694 66.9374 51.4475 55.6864 51.95L55.6971 51.9527ZM55.6971 41.4608V34.5454H71.3948V24H28.6556V34.5454H44.3507V41.4581C31.5936 42.0488 22 44.5963 22 47.649C22 50.7017 31.5936 53.2465 44.3507 53.8399V76H55.6944V53.8319C68.4223 53.2411 78 50.6963 78 47.6463C78 44.5963 68.4302 42.0515 55.6944 41.4581L55.6971 41.4608Z"
      fill="white"
    />
  </svg>
);
